import * as Yup from 'yup';

// Function to check if an object is a file
const isFileObject = (value) => {
    return value && typeof value === 'object' && 'name' in value && 'lastModified' in value;
  };

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Name is required')
    .min(2, 'Name must be at least 2 characters long'),
 image: Yup.mixed()
    .test(
      'is-valid-file',
      `primary image must be a valid image file or URL`,
      (item) => {
        if (typeof item === 'string') {
          // Allow URLs as valid too
          return Yup.string()
            .url(`primary image must be a valid URL`)
            .matches(/\.(jpeg|jpg|png|webp)$/, `primary image must be a valid image URL`)
            .isValidSync(item);
        } else if (isFileObject(item)) {
          const validFileExtensions = /\.(jpeg|jpg|png|webp)$/;
          return validFileExtensions.test(item.name);
        }
        return false; // Invalid type
      }
    )
    .required(`primary image is required`),

  delivery_calculation: Yup.string()
    .required('Delivery calculation is required'),

  categoryType: Yup.string()
    .required('Category type is required'),

  is_visible: Yup.boolean()
    .required('Visibility status is required')
});

export default validationSchema;
